const carouselItems = [
  {
    title: '顶流男星密会风波全追踪',
    desc: '从深夜被拍到工作室回应，完整时间线梳理',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20digital%20illustration%20with%20warm%20coral%20and%20deep%20red%20gradient%20tones%2C%20geometric%20shapes%20representing%20celebrity%20news%20tracking%2C%20modern%20editorial%20style%2C%20clean%20composition%2C%20soft%20lighting%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '吃瓜大赛第51届全程回顾',
    desc: '从海选到决赛，高能名场面一次看完',
    tag: '赛事',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20energetic%20digital%20art%20with%20warm%20orange%20and%20gold%20gradients%2C%20dynamic%20flowing%20shapes%20representing%20competition%20highlights%2C%20modern%20minimalist%2C%20clean%20background%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '网红直播圈大起底',
    desc: '带货翻车、虚假宣传，近期网红圈风波汇总',
    tag: '盘点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20illustration%20with%20warm%20peach%20and%20coral%20gradients%2C%20layered%20geometric%20forms%20representing%20social%20media%20analysis%2C%20modern%20editorial%20quality%2C%20clean%20composition%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: '暑期热剧收视大战',
    desc: '多部大剧同期对打，谁能笑到最后？',
    tag: '热议',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20soft%20gold%20digital%20art%20representing%20TV%20drama%20showdown%2C%20geometric%20contrast%20shapes%2C%20modern%20minimalist%20style%2C%20clean%20background%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    title: '综艺名场面合集',
    desc: '那些年综艺里让人难忘的经典瞬间',
    tag: '合集',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20colorful%20digital%20art%20with%20warm%20terracotta%20and%20coral%20gradients%2C%20playful%20geometric%20patterns%20representing%20variety%20show%20moments%2C%20modern%20editorial%2C%20clean%20composition%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-05&orientation=landscape',
  },
  {
    title: '本月热搜TOP20大盘点',
    desc: '全网热搜事件月度总结，一网打尽',
    tag: '月报',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20rose%20gradient%20digital%20illustration%20representing%20monthly%20recap%20and%20statistics%2C%20circular%20geometric%20elements%2C%20modern%20minimalist%20style%2C%20clean%20background%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            📰 焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选深度专题报道，吃瓜也要吃出门道
          </p>
        </div>

        <div className="overflow-x-auto pb-4">
          <div className="flex gap-5" style={{ minWidth: 'max-content' }}>
            {carouselItems.map((item, i) => (
              <div
                key={i}
                className="flex-shrink-0 w-[280px] md:w-[320px] bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200/50 cursor-pointer group"
              >
                <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}